export const container = `w-full flex flex-row lg:flex-col items-baseline gap-x-4 gap-y-1 text-xs`;
export const duration = `text-sm font-medium text-gray-800`;
export const distance = `font-normal text-gray-400`;
export const loading = `block w-full h-4 bg-gray-200 rounded animate-pulse`;
